// Trocar o e-mail da conta: pede a senha (e o código do 2º fator, se ligado); a troca vale só depois do link enviado ao e-mail novo.
import { useState, type FormEvent } from 'react'
import { api, errorMessage } from '../../lib/api'
import { useSession } from '../../lib/session'
import { FormError, FormOk } from './AuthShell'
import PasswordInput from './PasswordInput'

export default function ChangeEmailCard() {
  const { me } = useSession()
  const [newEmail, setNewEmail] = useState('')
  const [password, setPassword] = useState('')
  const [code, setCode] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [sentTo, setSentTo] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  if (!me) return null

  async function submit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setSentTo(null)
    setBusy(true)
    try {
      await api.post('/auth/change-email', { newEmail, password, ...(me!.user.totpEnabled ? { code } : {}) })
      setSentTo(newEmail.trim())
      setNewEmail(''); setPassword(''); setCode('')
    } catch (err) { setError(errorMessage(err)) } finally { setBusy(false) }
  }

  return (
    <form className="card stack" style={{ gap: 14 }} onSubmit={submit}>
      <h2>Trocar e-mail</h2>
      {!me.user.hasPassword ? (
        <p className="small muted">Para trocar o e-mail, crie uma senha primeiro: saia e use “Esqueci a senha” na tela de entrada.</p>
      ) : (
        <>
          <p className="small muted">Enviamos um link para o e-mail novo. O e-mail só muda quando você abrir esse link, e os outros aparelhos serão desconectados.</p>
          <FormError error={error} />
          {sentTo && <FormOk>Enviamos um link para {sentTo}. Abra-o para concluir a troca.</FormOk>}
          <div className="field"><label htmlFor="pf-newemail">E-mail novo</label><input id="pf-newemail" className="input" type="email" autoComplete="email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} required /></div>
          <div className="field"><label htmlFor="pf-emailpass">Sua senha</label><PasswordInput id="pf-emailpass" value={password} onChange={setPassword} autoComplete="current-password" /></div>
          {me.user.totpEnabled && (
            <div className="field"><label htmlFor="pf-emailcode">Código de 6 números do aplicativo</label><input id="pf-emailcode" className="input" inputMode="numeric" autoComplete="one-time-code" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} required /></div>
          )}
          <button className="btn primary" style={{ alignSelf: 'flex-start' }} disabled={busy}>Enviar link</button>
        </>
      )}
    </form>
  )
}
